import axios from 'axios';

let REACT_APP_SERVER = '/';

axios.defaults.baseURL = REACT_APP_SERVER;

// Quando o backend recusa um token (401) a sessao expirou ou o token e invalido:
// quem registrar o handler decide como encerrar a sessao no app.
let unauthorizedHandler = null;

axios.interceptors.response.use(
    (response) => response,
    (error) => {
        const status = error?.response?.status;
        const sentToken = !!error?.config?.headers?.Authorization;
        if (status === 401 && sentToken && unauthorizedHandler) {
            unauthorizedHandler(error);
        }
        return Promise.reject(error);
    },
);

function getHeader(user) {
    if (user && user.isAuthenticated) {
        return {
            headers: {
                Authorization: `Bearer ${user.token}`,
                'Content-Type': 'application/json;charset=UTF-8'
            },
        };
    } else {
        return {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8'
            }
        };
    }
}

/* eslint-disable import/no-anonymous-default-export */
export default {
    setUnauthorizedHandler(handler) {
        unauthorizedHandler = handler;
    },

    async userLogin(endpoint, user) {
        return await axios.post(endpoint, user);
    },

    async getDocumentsPaginated(user, page = 1, limit = 5, searchTerm = '', filter) {
        const endpoint = user?.isAuthenticated ? 'Admin/ListarTodosAPI' : 'Home/ListarAtivos';
        const { data } = await axios.post(
            endpoint,
            {
                Busca: searchTerm,
                PageSize: limit,
                PageNumber: page,
                ...filter,
            },
            getHeader(user),
        );
        return data;
    },

    async getDocumentsAll(user, searchTerm = '', filter) {
        const endpoint = user?.isAuthenticated ? 'Admin/ListarTodosAPI' : 'Home/ListarAtivos';
        const { data } = await axios.post(
            endpoint,
            {
                Busca: searchTerm,
                ...filter,
            },
            getHeader(user),
        );
        return data;
    },

    async getReport(user, searchTerm = '', filter) {
        const endpoint = 'Admin/RelatorioDocumentos';
        const { data } = await axios.post(
            endpoint,
            {
               filter,
            },
            getHeader(user),
        );
        return data;
    },

    async getDocumentById(id, tipoDoc) {
        return await axios.get(`Home/Item/?ID=${id}&TipoDoc=${tipoDoc}`); //Add TipoDoc 1 NTS ou 2 DPS
    },

    async postDocument(user, document) {
        return await axios.post(`Admin/SalvarAPI`, document, getHeader(user));
    },

    async postStatus(user, id, status, tipoDoc) {
        return await axios.post(`Admin/MudancaStatus/?ID=${id}&Status=${status}&TipoDoc=${tipoDoc}`, {}, getHeader(user));
    },

    async deleteDocument(user, id, tipoDoc) {
        return await axios.post(`Admin/Excluir?ID=${id}&TipoDoc=${tipoDoc}`, {}, getHeader(user));
    },

    async getClassificacoes() {
        return await axios.post(`Classificacao/ListarPaginadoAPI`, {
            Busca: '',
        });
    },

    async getClassificacoesPaginated(page = 1, limit = 2) {
        return await axios.post(`Classificacao/ListarPaginadoAPI`, {
            PageSize: limit,
            PageNumber: page,
        });
    },

    // Tags sao dados administrativos: exigem usuario autenticado.
    async getTags(user) {
        return axios.post(`Admin/Tags`, {}, getHeader(user));
    },

    async deleteClassificacoes(user, id) {
        return await axios.post(`Classificacao/Delete?ID=${id}`, {}, getHeader(user));
    },

    async postClassificacao(user, classificacao) {
        return await axios.post(`Classificacao/Salvar`, classificacao, getHeader(user));
    },

    getThumbnail(id, tipoDoc) {
        return `${REACT_APP_SERVER}Home/Thumbnail?ID=${id}&TipoDoc=${tipoDoc}`;
    },

    getLink(id) {
        return `${REACT_APP_SERVER}Home/Link?ID=${id}`;
    },

    getArquivo(id, tipoDoc, ignoreTab = true) {
        const data = ignoreTab
            ? `${REACT_APP_SERVER}Home/Arquivo?ID=${id}&ignoreTab=${ignoreTab}&TipoDoc=${tipoDoc}`
            : axios.get(`Home/Arquivo?ID=${id}&ignoreTab=${ignoreTab}&TipoDoc=${tipoDoc}`, {
                responseType: 'arraybuffer',
            });

        return data;
    },

    async getVersoes(tipoDoc, page, limit, document) {
        return await axios.post(`Home/ListarHistorico`, {
            PageSize: limit,
            PageNumber: page,
            Busca: document,
            TipoDoc: tipoDoc
        });
    },
};
